"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BroadcastAddress_1 = require("./BroadcastAddress");
var NetworkAddress_1 = require("./NetworkAddress");
var FirstHost_1 = require("./FirstHost");
var LastHost_1 = require("./LastHost");
var Mask_1 = require("./Mask");
var CidrInfo_1 = require("./CidrInfo");
var Contains_1 = require("./Contains");
var Network = /** @class */ (function () {
    function Network(subnet) {
        this.sub = subnet;
    }
    Network.prototype.broadcastAddress = function () {
        return BroadcastAddress_1.broadcastAddress(this.sub);
    };
    Network.prototype.networkAddress = function () {
        return NetworkAddress_1.networkAddress(this.sub);
    };
    Network.prototype.firstHost = function () {
        return FirstHost_1.firstHost(this.sub);
    };
    Network.prototype.lastHost = function () {
        return LastHost_1.lastHost(this.sub);
    };
    Network.prototype.info = function () {
        return CidrInfo_1.cidrInfo(this.sub);
    };
    Network.prototype.mask = function () {
        return Mask_1.mask(this.sub);
    };
    Network.prototype.contains = function (ip) {
        return Contains_1.contains(this.sub, ip);
    };
    return Network;
}());
exports.Network = Network;
function subnet(network) {
    return new Network(network);
}
exports.subnet = subnet;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VibmV0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiU3VibmV0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsdURBQWtFO0FBQ2xFLG1EQUErRDtBQUMvRCx5Q0FBZ0Q7QUFDaEQsdUNBQTZDO0FBQzdDLCtCQUE4QztBQUM5Qyx1Q0FBcUM7QUFFckMsdUNBQWtEO0FBRWxEO0lBRUUsaUJBQWEsTUFBYztRQUN6QixJQUFJLENBQUMsR0FBRyxHQUFHLE1BQU0sQ0FBQTtJQUNuQixDQUFDO0lBQ0Qsa0NBQWdCLEdBQWhCO1FBQ0UsTUFBTSxDQUFDLG1DQUFTLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQzVCLENBQUM7SUFDRCxnQ0FBYyxHQUFkO1FBQ0UsTUFBTSxDQUFDLCtCQUFVLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQzdCLENBQUM7SUFDRCwyQkFBUyxHQUFUO1FBQ0UsTUFBTSxDQUFDLHFCQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ3hCLENBQUM7SUFDRCwwQkFBUSxHQUFSO1FBQ0UsTUFBTSxDQUFDLG1CQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ3ZCLENBQUM7SUFDRCxzQkFBSSxHQUFKO1FBQ0UsTUFBTSxDQUFDLG1CQUFRLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQzNCLENBQUM7SUFDRCxzQkFBSSxHQUFKO1FBQ0UsTUFBTSxDQUFDLFdBQWEsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDaEMsQ0FBQztJQUNELDBCQUFRLEdBQVIsVUFBVSxFQUFVO1FBQ2xCLE1BQU0sQ0FBQyxtQkFBUyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUE7SUFDaEMsQ0FBQztJQUNILGNBQUM7QUFBRCxDQUFDLEFBMUJELElBMEJDO0FBMUJZLDBCQUFPO0FBNEJwQixnQkFBd0IsT0FBZTtJQUNyQyxNQUFNLENBQUMsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUE7QUFDN0IsQ0FBQztBQUZELHdCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/Subnet.ts
// module id = 20
// module chunks = 0